import { Badge, Box, Flex, IconButton, Link, ListItem, Text, Tooltip, UnorderedList, Button as ChakraButton } from "@chakra-ui/react";
import { ColumnsType } from "antd/lib/table";
import { Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { cpf_cnpj, formatDate, getColorBadgeStatus, getInvoiceStatus, showToast,clearMask } from "../../utils";
import { Filter } from "../../components/Filter";
import { format } from "date-fns";
import { DownloadButton } from "../../components/DownloadButton";
import { ShareIcon } from "../../styles/icons/ShareIcon";
import { Alert } from "../../components/Alert";
import { useInvoice } from "../../hooks/useInvoice";
import { cnpj } from "cpf-cnpj-validator";
import { ListInvoiceData } from "../../models/Invoice";
import { LinkButton, Button } from "./styles";
import { DownloadIcon } from "../../styles/icons/DownloadIcon";
import Promise from 'bluebird';
import JsZip from 'jszip';
import FileSaver from 'file-saver';
import { PaperIcon } from "../../styles/icons/PaperIcon";
import { PlusCircle } from "../../styles/icons/PlusCircle";
import { InvoiceIcon } from "../../styles/icons/InvoiceIcon";
import { ImportInvoiceForm } from "./_ImportInvoiceForm";
import { CreateInvoiceForm } from "./_CreateInvoiceForm";

export function InvoiceTable() {
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [isShareAlertOpen, setIsShareAlertOpen] = useState(false);
    const [isDownloadAlertOpen, setIsDownloadAlertOpen] = useState(false);
    const [cancelInvoiceAlertOpen, setCancelInvoiceAlertOpen] = useState(false);
    const [isCreateInvoiceModalOpen, setIsCreateInvoiceModalOpen] = useState(false);
    const [isImportInvoiceModalOpen, setIsImportInvoiceModalOpen] = useState(false);
    const [startDate, setStartDate] = useState<Date | null>();
    const [endDate, setEndDate] = useState<Date | null>();
    const [selectedInvoice, setSelectedInvoice] = useState<any>();
    const [initialData, setInitialData] = useState<ListInvoiceData[]>([]);
    const shareAlertRef = useRef();
    const cancelAlertRef = useRef();
    const { getInvoices, sendInvoiceEmail, cancelInvoice } = useInvoice();


    const getInitialData = async (filter: object, pageable: object) => {
        try {
            const response = await getInvoices(filter, pageable);
            setInitialData(response.data.content);
        } catch {

        }
    }
    useEffect(() => {
        getInitialData({ sort: "createdAt,desc" }, { size: 10000, cnpj: 44522660000108 });
        //eslint-disable-next-line
    }, []);

    const handleSendEmail = async () => {
        try {
            await sendInvoiceEmail(selectedInvoice?.uuidInvoice);
            showToast({
                message: "E-mail enviado com sucesso!",
                type: "success",
            });
        } catch (error) {
            //@ts-ignore
            error?.response?.data?.errors.map((itemError) => {
                return showToast({
                    message: `${itemError?.description} - ${itemError?.code}`,
                    type: "error",
                });
            });
        } finally {
            setIsShareAlertOpen(false);
        }
    }

    const handleCancelInvoice = async () => {
        try {
            await cancelInvoice(selectedInvoice?.uuidInvoice);
            showToast({
                message: "Nota fiscal deletada com sucesso!",
                type: "success",
            });
        } catch (error) {
            //@ts-ignore
            error?.response?.data?.errors.map((itemError) => {
                return showToast({
                    message: `${itemError?.description} - ${itemError?.code}`,
                    type: "error",
                });
            });
        } finally {
            setCancelInvoiceAlertOpen(false);
        }
    }

    const invoiceTableColumns: ColumnsType<any> = [
        {
            key: "sellerDocument",
            title: "CNPJ",
            dataIndex: "sellerDocument",
            render: (sellerDocument, record) => (
                <Tooltip label={cpf_cnpj(record?.sellerDocument)}>
                    <Text noOfLines={1}>
                        {cpf_cnpj(record?.sellerDocument)}
                    </Text>
                </Tooltip>
            )
        },
        {
            key: "sellerName",
            title: "Razão Social",
            dataIndex: "sellerName",
            render: (sellerName, record) => (
                <Tooltip label={record?.sellerName}>
                    <Text noOfLines={1}>
                        {record?.sellerName}
                    </Text>
                </Tooltip>
            )
        },
        {
            key: "invoiceNumber",
            title: "Número da NF",
            dataIndex: "invoiceNumber",
            render: (invoiceNumber, record) => (
                <Text
                    fontWeight={700}
                >
                    {record?.invoiceNumber}
                </Text>
            )
        },
        {
            key: "createdAt",
            title: "Data de Emissão",
            dataIndex: "createdAt",
            render: (createdAt, record) => (
                <Text
                    fontWeight={700}
                >
                    {formatDate(record?.createdAt)}
                </Text>
            )
        },
        {
            key: "status",
            title: "Status",
            dataIndex: "status",
            render: (status, record) => (
                record?.status === "FAILED" ? (
                    <Badge
                        variant={getColorBadgeStatus(record?.status)}
                        fontWeight={700}
                    >
                        <Tooltip label={record?.errorReason}>
                            {getInvoiceStatus(record?.status)}
                        </Tooltip>
                    </Badge>
                ) : (
                    <Badge
                        variant={getColorBadgeStatus(record?.status)}
                        fontWeight={700}
                    >
                        {getInvoiceStatus(record?.status)}
                    </Badge>
                )

            )
        },
        {
            key: "buttonOptions",
            title: "",
            render: (text, record) => (
                <Box p="0" w="200px" h="40px">
                    <Flex
                        w="100%"
                        h="40px"
                        align="center"
                        gap="4"
                        className="rowAction"
                    >
                        {(record?.status === "AUTHORIZED") && (
                            <ChakraButton
                                variant="cancel"
                                onClick={() => {
                                    setSelectedInvoice(record);
                                    setCancelInvoiceAlertOpen(true)
                                }}
                            >
                                Cancelar
                            </ChakraButton>
                        )}
                        <Flex
                            align="center"
                            justify="center"
                            h="40px"
                            w="40px"
                            transition="all .2s"
                            _hover={{
                                transition: "all .2s",

                            }}
                        >
                            <DownloadButton disabled={Object.keys(record?.invoiceDownloadLink).length === 0}>
                                {record?.invoiceDownloadLink?.pdfImageLink && (
                                    <Link
                                        w="100%"
                                        textAlign="center"
                                        _hover={{
                                            borderRadius: "5px",
                                            bgColor: "gray.50"
                                        }}
                                        href={record?.invoiceDownloadLink?.pdfImageLink}
                                        download="FileName"
                                    >
                                        PDF
                                    </Link>
                                )}
                                {record?.invoiceDownloadLink?.xmlImageLink && (
                                    <Link
                                        w="100%"
                                        textAlign="center"
                                        _hover={{
                                            borderRadius: "5px",
                                            bgColor: "gray.50"
                                        }}
                                        href={record?.invoiceDownloadLink?.xmlImageLink}
                                        target="_blank"
                                    >
                                        XML
                                    </Link>
                                )}
                            </DownloadButton>
                        </Flex>
                        <Flex
                            align="center"
                            justify="center"
                            h="40px"
                            w="40px"
                            transition="all .2s"
                            _hover={{
                                transition: "all .2s",
                            }}
                        >
                            <IconButton
                                bgColor="transparent"
                                aria-label="Compartilhar com e-mail"
                                w="30px"
                                h="35px"
                                icon={<ShareIcon opacity="0.45" />}
                                isDisabled={!record?.uuidInvoice}
                                onClick={() => {
                                    setSelectedInvoice(record);
                                    setIsShareAlertOpen(!isShareAlertOpen);
                                }}
                            />
                        </Flex>

                    </Flex>
                </Box>
            ),
        },
    ];

    function onSubmitSearch(searchParam: string) { 
        const searchDates = {
            executionDateInitial: startDate ? format(startDate, "yyyy-MM-dd") : "",
            executionDateFinal: endDate ? format(endDate, "yyyy-MM-dd") : "",
        }
        if(searchParam === "") return getInitialData({...searchDates}, { size: 10000 });
        const hasOnlyNumber = /^\d/.test(clearMask(searchParam));
        if(hasOnlyNumber && cnpj.isValid(clearMask(searchParam))) return getInitialData({ ...searchDates, cnpj: clearMask(searchParam) }, { size: 10000 });
        if(hasOnlyNumber && !cnpj.isValid(searchParam)) return getInitialData({ ...searchDates, invoiceNumber: searchParam }, { size: 10000 });
        getInitialData({ ...searchDates, companyName: searchParam }, { size: 10000 });
    }

    const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const download = async (url: string) => {
        return fetch(url).then(resp => resp.blob());
    };

    const downloadByGroup = async (urls, files_per_group = 5) => {
        return Promise.map(
            urls,
            async (url: string) => {
                if (url === undefined) return
                return await download(url);
            },
            { concurrency: files_per_group }
        );
    }

    const exportZip = blobs => {
        const zip = JsZip();
        blobs.forEach((blob, i) => {
            if (blob === undefined) return
            zip.file(`nota-${i}.pdf`, blob);
        });
        zip.generateAsync({ type: 'blob' }).then(zipFile => {
            const fileName = `notas_fiscais.zip`;
            return FileSaver.saveAs(zipFile, fileName);
        });
    }

    const handleDownloadInvoice = async () => {
        const getSelectedsInvoices = initialData?.filter(invoice => selectedRowKeys.includes(invoice.uuidInvoice));
        const getPdfLinks = getSelectedsInvoices?.map(selectedInvoice => selectedInvoice?.invoiceDownloadLink?.pdfImageLink);
        setIsDownloadAlertOpen(false);
        return downloadByGroup(getPdfLinks, 5).then(exportZip);
    }


    return (
        <>
            <CreateInvoiceForm
                isOpen={isCreateInvoiceModalOpen}
                onClose={() => setIsCreateInvoiceModalOpen(false)}
            />

            <ImportInvoiceForm
                isOpen={isImportInvoiceModalOpen}
                onClose={() => setIsImportInvoiceModalOpen(false)}
            />
            <Alert
                closeButtonText="Não"
                confirmButtonText="Sim"
                isOpen={isDownloadAlertOpen}
                onConfirm={handleDownloadInvoice}
                onClose={() => {
                    setIsDownloadAlertOpen(!isDownloadAlertOpen);
                }}
                title={`Deseja realmente baixar as notas fiscais?`}
                leastDestructiveRef={cancelAlertRef}
            />
            <Alert
                closeButtonText="Não"
                confirmButtonText="Sim"
                isOpen={cancelInvoiceAlertOpen}
                onConfirm={handleCancelInvoice}
                onClose={() => {
                    setSelectedInvoice({});
                    setCancelInvoiceAlertOpen(!cancelInvoiceAlertOpen);
                }}
                title={`Deletar nota fiscal No - ${selectedInvoice?.invoiceNumber ?? ""} ?`}
                leastDestructiveRef={cancelAlertRef}
            />
            <Alert
                closeButtonText="Não"
                confirmButtonText="Sim"
                isOpen={isShareAlertOpen}
                onConfirm={handleSendEmail}
                onClose={() => {
                    setSelectedInvoice({});
                    setIsShareAlertOpen(!isShareAlertOpen);
                }}
                title="Enviar Nota Fiscal ao cliente por email ?"
                leastDestructiveRef={shareAlertRef}
            >
                <UnorderedList>
                    {selectedInvoice?.invoiceEmails?.map(invoiceEmails => <ListItem>{invoiceEmails}</ListItem>)}
                </UnorderedList>
            </Alert>
            <section className="titleSection">
                <span>
                    <InvoiceIcon size={35} />
                    <h1>Notas Fiscais</h1>
                </span>
                <section className="buttonSection">
                    <LinkButton onClick={() => setIsDownloadAlertOpen(true)}>
                        <DownloadIcon color="#1890FF" />
                        <text>Baixar notas selecionadas</text>
                    </LinkButton>
                    <Button
                        onClick={() => setIsCreateInvoiceModalOpen(!isCreateInvoiceModalOpen)}
                    >
                        <PlusCircle color="#FFF" />
                        <text>Emitir NF individual</text>
                    </Button>
                    <Button
                        onClick={() => setIsImportInvoiceModalOpen(!isImportInvoiceModalOpen)}
                    >
                        <PaperIcon color="#FFF" />
                        <text>Emitir NF por .csv</text>
                    </Button>
                </section>
            </section>
            <Flex
                w="100%"
                flexDirection="column"
            >
                <Filter
                    placeholder="Buscar Nota Fiscal"
                    onSubmitSearch={onSubmitSearch}
                    needToSubmit
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    startDate={startDate}
                    endDate={endDate}
                    isVisibleDatepicker
                />
                <Table
                    columns={invoiceTableColumns}
                    dataSource={initialData}
                    rowKey={(record) => record.uuidInvoice}
                    rowSelection={rowSelection}
                    locale={{ emptyText: "Sem notas fiscais cadastradas" }}
                />
            </Flex>
        </>
    )
}